import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { userStatuses } from '@/const'
import { OUTLET_DETAILS_PAGE_NAME, OUTLET_UPDATE_PAGE_NAME } from '@/components/pages/cabinet/routes'
import { USER_STATUS_COLOR_MAP } from '@/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'OutletCard',
  props: {
  outlet: Object,
},
  emits: ['select'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { $t } = useGlobal()
const emit = __emit
const props = __props
const { id, externalId, title, group, sellers, region, address } = props.outlet

const val = ref(false)

function setValue(val) {
  emit("select", props.outlet.id)
}


const __returned__ = { $t, emit, props, id, externalId, title, group, sellers, region, address, val, setValue, ref, get useGlobal() { return useGlobal }, get userStatuses() { return userStatuses }, get OUTLET_DETAILS_PAGE_NAME() { return OUTLET_DETAILS_PAGE_NAME }, get OUTLET_UPDATE_PAGE_NAME() { return OUTLET_UPDATE_PAGE_NAME }, get USER_STATUS_COLOR_MAP() { return USER_STATUS_COLOR_MAP } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})